/**
 * Decorative page illustrations. Each is purely presentational — the
 * information they echo is always stated in text nearby — so they are hidden
 * from assistive technology.
 */

const EXPORT_KINDS = [
  { label: 'TALLY EXPORT', accent: 'from-[#f0776a] to-[#f7b3aa]' },
  { label: 'BANK CSV', accent: 'from-[#f0b429] to-[#f7d894]' },
  { label: 'CRM DATA', accent: 'from-[#12946b] to-[#7fd8ba]' },
  { label: 'PURCHASES', accent: 'from-[#7c5cd6] to-[#b6a2ec]' },
  { label: 'OPERATIONS', accent: 'from-primary to-[#93a8f5]' },
  { label: 'ANONYMISED', accent: 'from-[#8b98a9] to-[#c9d3e4]' },
]

/** The grid of export types shown under the contact hero. */
export function ExportKindsGrid() {
  return (
    <ul
      aria-hidden="true"
      className="mx-auto mt-14 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4"
    >
      {EXPORT_KINDS.map((kind) => (
        <li
          key={kind.label}
          className="rounded-card border border-line bg-white p-4 shadow-card sm:p-5"
        >
          <span className={`block h-1 w-9 rounded-full bg-gradient-to-r ${kind.accent}`} />
          <span className="mt-3 block font-mono text-[9.5px] tracking-[0.14em] text-muted">
            {kind.label}
          </span>
          <span className="mt-3 block h-1.5 w-full rounded-full bg-line" />
          <span className="mt-2 block h-1.5 w-3/5 rounded-full bg-line" />
        </li>
      ))}
    </ul>
  )
}

const TRACE_RUNGS = [
  { label: 'SOURCE', dot: 'S1', chip: 'bg-[#f0776a]', line: 'from-[#f0776a]', width: 'w-[68%]' },
  {
    label: 'EXTRACTION',
    dot: 'S2',
    chip: 'bg-[#f0b429]',
    line: 'from-[#f0b429]',
    width: 'w-[78%]',
  },
  {
    label: 'CALCULATION',
    dot: 'S3',
    chip: 'bg-[#12946b]',
    line: 'from-[#12946b]',
    width: 'w-[86%]',
  },
  { label: 'MODEL CHECK', dot: 'S4', chip: 'bg-primary', line: 'from-primary', width: 'w-[94%]' },
  { label: 'PROJECTION', dot: 'S5', chip: 'bg-violet', line: 'from-violet', width: 'w-full' },
]

/** The five-rung trace ladder shown under the provenance hero. */
export function TraceLadder() {
  return (
    <div aria-hidden="true" className="mx-auto mt-14 grid max-w-3xl gap-3">
      {TRACE_RUNGS.map((rung) => (
        <div key={rung.label} className="flex items-center gap-3 sm:gap-4">
          <span
            className={`inline-flex flex-none items-center rounded-control px-3 py-1.5 font-mono text-[9.5px] tracking-[0.12em] text-white ${rung.chip}`}
          >
            {rung.label}
          </span>
          <span className="relative flex min-w-0 flex-1 items-center">
            <span
              className={`h-[2px] rounded-full bg-gradient-to-r to-transparent ${rung.line} ${rung.width}`}
            />
          </span>
          <span className="flex flex-none items-center gap-1.5">
            <span className={`h-1.5 w-1.5 rounded-full ${rung.chip}`} />
            <span className="font-mono text-[9.5px] text-muted-soft">{rung.dot}</span>
          </span>
        </div>
      ))}
    </div>
  )
}
